import React from 'react'
import MonthSelector from './BudgetCalendars/MonthSelector'
import YearSelector from './BudgetCalendars/YearSelector'
import UserBudgetExpenses from './UserBudgetExpenses'
import UserBudgetIncomes from './UserBudgetIncomes'

function UserFinances({setTotalIncome, setTotalExpenses, month, setMonth, months, years, year, setYear}) {

    return (
        <div className="row my-5">

            <YearSelector years={years} year={year} setYear={setYear} month={month} />
            <MonthSelector months={months} month={month} setMonth={setMonth} year={year} />

            <div className="col-md-6">
                <UserBudgetIncomes setTotalIncome={setTotalIncome} month={month} year={year} />
            </div>
            <div className="col-md-6">
                <UserBudgetExpenses setTotalExpenses={setTotalExpenses} month={month} year={years[year]} />
            </div>
            
        </div>
    )
}
export default UserFinances